import React from "react";
import { ReadOnlyProps } from "../../../utils/templates";
import { TouchableOpacity, StyleSheet } from "react-native";

import { renameLabel } from "../../../utils/common";
import { Text } from "react-native";

interface Props {
  itemsList: Array<string>;
  filterCategory: string | string[];
  setFilterCategory: (category: any) => void;
}

export const BadgeHorizontalList: React.FC<Props> = (
  props: ReadOnlyProps<Props>
) => {
  return (
    <>
      {props.itemsList.map((item) => {
        const isActive = Array.isArray(props.filterCategory)
          ? (props.filterCategory.length === 0 && item.toLowerCase() === "all" ? true : props.filterCategory.includes(item))
          : props.filterCategory === item;

        return (
          <TouchableOpacity
            key={item}
            style={[
              styles.filterButton,
              isActive && styles.activeFilterButton,
            ]}
            onPress={() => {
              if (Array.isArray(props.filterCategory)) {
                if (item.toLowerCase() === "all" || item === "") {
                  props.setFilterCategory([]);
                } else {
                  const newArr = props.filterCategory.includes(item)
                    ? props.filterCategory.filter((i: string) => i !== item)
                    : [...props.filterCategory, item];
                  props.setFilterCategory(newArr);
                }
              } else {
                props.setFilterCategory(item);
              }
            }}
          >
            <Text
              style={
                isActive
                  ? styles.activeFilterText
                  : styles.filterText
              }
            >
              {renameLabel(item)}
            </Text>
          </TouchableOpacity>
        );
      })}
    </>
  );
};

const styles = StyleSheet.create({
  filterButton: {
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: "#F1F5F9",
    borderRadius: 999,
    marginRight: 8,
    marginBottom: 6,
    borderWidth: 1,
    borderColor: "#E2E8F0",
  },
  activeFilterButton: {
    backgroundColor: "#61B8FF",
    borderColor: "#61B8FF",
  },
  filterText: {
    fontSize: 13,
    color: "#475569",
    fontWeight: "500",
  },
  activeFilterText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },
});
